import { render, staticRenderFns } from "./dot_updater.vue?vue&type=template&id=45cc0ac4&"
import script from "./dot_updater.vue?vue&type=script&lang=js&"
export * from "./dot_updater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports